import { Request, Response, NextFunction } from 'express';
import { AuthRequest } from '../../middleware/auth.middleware';
import * as service from './teams.service';
import { getIo } from '../../realtime/socket.bootstrap';

export async function create(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const team = await service.createTeam(req.body.workspaceId, req.user!.sub, req.body);
    getIo()?.emit('TEAM_CREATED', team);
    res.status(201).json({ success: true, data: team });
  } catch (err) { next(err); }
}

export async function list(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const teams = await service.listTeams(req.query.workspaceId as string, req.user!.sub);
    res.json({ success: true, data: teams });
  } catch (err) { next(err); }
}

export async function getOne(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const team = await service.getTeam(req.params.id, req.user!.sub);
    res.json({ success: true, data: team });
  } catch (err) { next(err); }
}

export async function addMember(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const member = await service.addMember(req.params.id, req.body.userId);
    res.json({ success: true, data: member });
  } catch (err) { next(err); }
}

export async function removeMember(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    await service.removeMember(req.params.id, req.params.userId);
    res.json({ success: true });
  } catch (err) { next(err); }
}

export async function update(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const team = await service.updateTeam(req.params.id, req.user!.sub, req.body);
    getIo()?.emit('TEAM_UPDATED', team);
    res.json({ success: true, data: team });
  } catch (err) { next(err); }
}

export async function remove(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    await service.deleteTeam(req.params.id, req.user!.sub);
    getIo()?.emit('TEAM_DELETED', { teamId: req.params.id });
    res.json({ success: true });
  } catch (err) { next(err); }
}
